export default __webpack_public_path__ + "static/media/AntyLucy_3.38a239ee.jpg";